<input
  #input
  class="search-input reactive-form-input form-control"
  type="text"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (keydown.enter)="handleEnter($event)"
  (input)="handleInput($event)" />
<div class="d-flex flex-wrap gap-2 mt-3">
  <app-pill
    *ngFor="let pill of selectedPillItems$ | async"
    [fontSize]="'0.875rem'"
    [padding]="'0.5rem 0.75rem'"
    [gap]="'0.25rem'"
    [showXButton]="true"
    [pillItem]="pill"
    (clicked)="handlePillRemoved(pill)" />
</div>
